import React from 'react'

import clsx from 'clsx'

import './index.scss'

type ContentWrapperProps = {
  className?: string
  children: React.ReactNode
  verticalPadding?: 'small' | 'medium' | 'large'
  style?: React.CSSProperties // Добавили поддержку style
}

export function ContentWrapper({
  children,
  className,
  verticalPadding = 'medium',
  style,
  ...rest
}: ContentWrapperProps) {
  return (
    <section
      className={clsx(
        'content-wrapper',
        `content-wrapper--${verticalPadding}`,
        className,
      )}
      style={style}
      {...rest}
    >
      {children}
    </section>
  )
}
